import React from "react";
import { Notification } from "@ftdr/blueprint-components-react";

type ErrorNotificationProps = {
  message?: string;
  dataTestId?: string;
  className?: string;
};

export const ErrorNotification = ({
  message,
  dataTestId,
  className,
}: ErrorNotificationProps): JSX.Element => {
  return (
    <Notification
      variant="inline"
      status="error"
      size="medium"
      showStatusLabel={true}
      inline={true}
      data-testid={dataTestId}
      className={className}
    >
      <>{message}</>
    </Notification>
  );
};
